import { render, staticRenderFns } from "./ViewGallery.vue?vue&type=template&id=496fc1dc"
import script from "./ViewGallery.vue?vue&type=script&lang=js"
export * from "./ViewGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports